import VueI18n from 'vue-i18n';
import Vue from 'vue';
import { getTranslations } from '@/commons/translation';
import it from 'vue2-datepicker/locale/it';
import en from 'vue2-datepicker/locale/en';
import ru from 'vue2-datepicker/locale/ru';
import pl from 'vue2-datepicker/locale/pl';
import de from 'vue2-datepicker/locale/de';
import fr from 'vue2-datepicker/locale/fr';
import es from 'vue2-datepicker/locale/es';
import cs from 'vue2-datepicker/locale/cs';
import bg from 'vue2-datepicker/locale/bg';
import sv from 'vue2-datepicker/locale/sv';

const storeOptions = JSON.parse(process.env.VUE_APP_STORE_OPTIONS);

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: storeOptions.locale || window.__INITIAL_STATE__.settings.locale,
    messages: getTranslations(),
});

export const datepickerLocales: any = {
    it: it,
    en: en,
    ru: ru,
    pl: pl,
    de: de,
    fr: fr,
    es: es,
    cs: cs,
    bg: bg,
    sv: sv
};